/*
 * @Author: Chris 
 * @Date: 2022-07-27 11:17:42 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-08 10:04:19
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/**
 *  解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
 */

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/**
 * 有权限控制的路由
 * */

export const asyncRouterMap = [
  {
    path: '/userManagement',
    name: 'UserManagement',
    meta: {
      title: "单位管理",
      layout: "ordinary",
      menuId: 1,
      icon: [require('/src/assets/IMG/menu/user_1.png'), require('/src/assets/IMG/menu/user.png')],
      roles: [
        "admin",
      ],
    },
    component: () => import('../views/userManagement/userManagement.vue')
  },
  
  {
    path: '/menuManagement',
    name: 'MenurManagement',
    meta: {
      title: "菜单管理",
      layout: "ordinary",
      menuId: 1,
      icon: [require('/src/assets/IMG/menu/user_1.png'), require('/src/assets/IMG/menu/user.png')],
      roles: [
        "admin",
      ],
    },
    component: () => import('../views/menuManagement/menuManagement.vue')
  },

  // {
  //   path: '/useUnitManagement',
  //   name: 'useUnitManagement',
  //   meta: {
  //     title: "使用单位管理",
  //     layout: "ordinary",
  //     menuId: 4,
  //     icon: [require('/src/assets/IMG/menu/user_1.png'), require('/src/assets/IMG/menu/user.png')],
  //     roles: [
  //       "admin", "master_admin"
  //     ],
  //   },
  //   component: () => import('../views/useUnitManagement/useUnitManagement.vue')
  // },  
  {
    path: '/organization',
    name: 'organization',
    meta: {
      title: "组织架构",
      layout: "ordinary",
      menuId: 2,
      icon: [require('/src/assets/IMG/menu/org_1.png'), require('/src/assets/IMG/menu/org.png')],
      roles: [
        "admin", "master_admin",
      ],
    },
    component: () => import('../views/organization/organization.vue')
  },
  // {
  //   path: '/systemManagement',
  //   name: 'systemManagement',
  //   meta: {
  //     title: "系统管理",
  //     layout: "ordinary",
  //     menuId: 3,
  //     icon: [require('/src/assets/IMG/menu/sys_1.png'), require('/src/assets/IMG/menu/sys.png')],
  //   },
  //   component: () => import('../views/systemManagement/systemManagement.vue')
  // },
]

/**
 * 不用权限控制的路由
 * 不显示在菜单里
 * */

export const defaultRouter = [
  {
    path: '/',
    redirect: '/login',
  },
  {
  path: '/login',
    name: 'login',
    meta: {
      title: "登录",
      layout: "noPermission",
      },
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/registration/:type/:Encrypted',
    name: 'registration',
    meta: {
      title: "注册",
      layout: "noPermission",
    },
    component: () => import('../views/registration/registration.vue')
  },
  {
    path: "/package/promotionService",
    name: "packagePromotionService",
    component: () => import("../views/privacyPolicy/packagePromotionService"),
    hidden: true,
    meta: {
      title: "服务协议",
      layout: "noPermission",
    },
  },
  {
    path: "*",
    name: "error",
    component: () => import("../views/errorPage/Error404"),
    meta: {
      title: "error",
      layout: "ordinary",
      isBreadClick: false,
      keepAlive: false,
    },
  },
]

/**
 * 路由汇总
 * */

export const routes = [...asyncRouterMap, ...defaultRouter];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;